<template>
  <div class="profile">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container mt--6 minHeight">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card no-body body-classes="px-0 pb-1" footer-classes="pb-2" class="createContentProviderContainer">
            <div slot="header" class="row align-items-center">
              <div class="col-lg-6 col-8">
                <h3 class="mb-0">{{ action === 'create' ? 'Add' : 'Update' }} Content Provider</h3>
              </div>
              <div class="col-lg-6 col-8">
                <router-link class="btn btn-primary pull-right" :to="cpCancelLink($route.query.q)">Back</router-link>
              </div>
            </div>

            <b-row id="cpFormContainer">
              <div class="col-lg-12 col-md-12 col-12">
                <b-card no-body>
                  <b-row v-if="currentUserGroup == 1">
                    <b-col md="12">
                      <div class="highlight-msg py-2 px-5">
                        <b-row>
                          <b-col>
                            <span class="text-gray text-sm text-uppercase">Company</span>
                            <h3 class="card-heading mb-1">{{ companyName }}</h3>
                          </b-col>
                        </b-row>
                      </div>
                      <hr class="m-0" />
                      <p class="text-center m-0">
                        <i class="fa fa-angle-down text-gray"></i>
                      </p>
                    </b-col>
                  </b-row>
                  <b-card-body class="pt-0">
                    <b-row v-if="loading">
                      <div class="col-lg-12 text-center">
                        <pulse-loader :color="'#3867d6'"></pulse-loader>
                      </div>
                    </b-row>
                    <b-row>
                      <form class="w-100">
                        <div class="p-lg-4 px-lg-4 px-md-4 px-sm-4">
                          <div v-if="action === 'edit'" class="row px-4">
                            <div class="col-lg-6">
                              <label class="w-100 form-control-label" for="">Account Number: </label>
                              <input
                                v-model.trim="accountNumber"
                                type="text"
                                class="form-control no-instruction"
                                name="accountNumber"
                                data-vv-as="accountNumber"
                                :disabled="true"
                                data-vv-name="accountNumber" />
                            </div>
                          </div>

                          <div class="row px-4">
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="clientName">Client Name </label>
                                <input
                                  v-model.trim="clientName"
                                  v-validate="'required'"
                                  type="text"
                                  name="clientName"
                                  data-vv-as="clientName"
                                  data-vv-name="clientName"
                                  placeholder="Enter Client Name"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('clientName'),
                                    'has-invalid': errors.has('clientName'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('clientName')">
                                  {{ errors.first('clientName') }}
                                </div>
                              </b-form-group>
                            </div>
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="name">Contact Name </label>
                                <input
                                  v-model.trim="name"
                                  v-validate="'required'"
                                  type="text"
                                  name="name"
                                  data-vv-as="name"
                                  data-vv-name="name"
                                  placeholder="Enter Contact Full Name"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('name'),
                                    'has-invalid': errors.has('name'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('name')">
                                  {{ errors.first('name') }}
                                </div>
                              </b-form-group>
                            </div>
                          </div>
                          <div class="row px-4">
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-0 has-feedback">
                                <b-form-group class="mb-0">
                                  <base-input label="Client Description" class="mb-0 w-100 form-control-label">
                                    <ckeditor id="benefitDescription" v-model="clientDescription" :editor="editor" :config="editorConfig"></ckeditor>
                                  </base-input>
                                  <small class="float-right mt-2 text-bold">{{ maxMessageCount - clientDescription.length }} Characters Remaining</small>
                                </b-form-group>
                              </b-form-group>
                            </div>
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="email">Contact Email </label>
                                <input
                                  id="email"
                                  v-model.trim="email"
                                  v-validate="'required|email'"
                                  type="email"
                                  name="email"
                                  data-vv-as="email"
                                  data-vv-name="email"
                                  placeholder="Enter Contact Email"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('email'),
                                    'has-invalid': errors.has('email'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('email')">
                                  {{ errors.first('email') }}
                                </div>
                              </b-form-group>
                              <b-form-group v-if="action === 'edit'" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="phone">Contact Phone </label>
                                <input
                                  v-model.trim="phone"
                                  v-validate="'required|phone'"
                                  type="text"
                                  name="phone"
                                  data-vv-name="phone"
                                  data-vv-delay="1000"
                                  placeholder="(999) 999-999"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('phone'),
                                    'has-invalid': errors.has('phone'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('phone')">
                                  {{ errors.first('phone') }}
                                </div>
                              </b-form-group>
                            </div>
                          </div>
                          <div v-if="unionTypes.length > 1 && false" class="row px-4">
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="unionTypeID">Select Union Type </label>
                                <b-form-select
                                  v-model="unionTypeID"
                                  v-validate="{ required: !isCompanyDefault }"
                                  :options="unionTypes"
                                  name="unionTypeID"
                                  placeholder="Please Union Type"
                                  class="form-control no-instruction"
                                  :class="{
                                    'is-invalid': errors.has('unionTypeID'),
                                    'has-invalid': errors.has('unionTypeID'),
                                  }">
                                </b-form-select>

                                <div class="invalid-feedback" :is-invalid="errors.has('unionTypeID')">
                                  {{ errors.first('unionTypeID') }}
                                </div>
                              </b-form-group>
                            </div>
                            <div class="col-lg-6">
                              <b-form-group v-if="action === 'create'" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="phone">Contact Phone </label>
                                <input
                                  v-model.trim="phone"
                                  v-validate="'required|phone'"
                                  type="text"
                                  name="phone"
                                  data-vv-name="phone"
                                  data-vv-delay="1000"
                                  placeholder="(999) 999-999"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('phone'),
                                    'has-invalid': errors.has('phone'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('phone')">
                                  {{ errors.first('phone') }}
                                </div>
                              </b-form-group>
                            </div>
                          </div>
                          <div class="row px-4">
                            <div class="col-lg-6">
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label v-if="!isCompanyDefault" class="w-100 form-control-label" for="typeID">Select Channel Type </label>
                                <div class="row">
                                  <div
                                    :class="{
                                      'col-lg-11': typeID !== null,
                                      'col-lg-12': typeID === null,
                                    }">
                                    <b-form-select
                                      v-if="!isCompanyDefault"
                                      v-model="typeID"
                                      :options="cpTypes"
                                      name="typeID"
                                      placeholder="Please Select Channel Type"
                                      class="form-control no-instruction">
                                    </b-form-select>
                                  </div>
                                  <div v-if="typeID !== null" class="col-lg-1 pt-2">
                                    <a v-b-tooltip.hover class="closeLinkContent text-gray" title="Clear Channel Type" @click="clearChannelType"
                                      ><i class="far fa-times-circle"></i
                                    ></a>
                                  </div>
                                </div>
                              </b-form-group>
                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label v-if="!isCompanyDefault && (isLocal === '1' || isLocal === '0')" class="w-100 form-control-label" for="categoryID"
                                  >{{ isLocal === '1' ? 'Select Category' : 'Select Category or Group' }}
                                </label>
                                <select
                                  v-if="!isCompanyDefault && isLocal === '0'"
                                  v-model="categoryID"
                                  v-validate="{ required: !isCompanyDefault }"
                                  name="categoryID"
                                  placeholder="Please Select Category or Group"
                                  class="form-control no-instruction"
                                  :class="{
                                    'is-invalid': errors.has('categoryID'),
                                    'has-invalid': errors.has('categoryID'),
                                  }">
                                  <option value="null" disabled="disabled">Please select category or group</option>

                                  <optgroup v-for="(group, name) in categories" :key="name" :label="name">
                                    <option v-for="(option, index) in group" :key="index" :value="option.value">
                                      {{ option.text }}
                                    </option>
                                  </optgroup>
                                </select>

                                <b-form-select
                                  v-if="!isCompanyDefault && isLocal === '1'"
                                  v-model="categoryID"
                                  v-validate="{ required: !isCompanyDefault }"
                                  :options="categoriesOnly"
                                  name="categoryID"
                                  placeholder="Please Select Category"
                                  class="form-control no-instruction"
                                  :class="{
                                    'is-invalid': errors.has('categoryID'),
                                    'has-invalid': errors.has('categoryID'),
                                  }">
                                </b-form-select>

                                <div class="invalid-feedback" :is-invalid="errors.has('categoryID')">
                                  {{ errors.first('categoryID') }}
                                </div>
                              </b-form-group>
                              <b-form-group role="group" class="mb-1 has-feedback">
                                <div class="row">
                                  <div class="col-lg-4 col-md-4">
                                    <label class="w-100 form-control-label small-label" for="isLocal"
                                      ><span class="pr-2">Primary</span>
                                      Secondary
                                    </label>
                                    <div class="row">
                                      <div class="col-lg-6 col-md-6">
                                        <base-radio v-model="isLocal" name="1" class="mb-3 ml-3"> </base-radio>
                                      </div>
                                      <div class="col-lg-6 col-md-6">
                                        <base-radio v-model="isLocal" name="0" class="mb-3"> </base-radio>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="isLocal === '0'" class="col-lg-4 col-md-4">
                                    <label class="w-100 form-control-label small-label" for="allowRegistration">Allow Registration </label>
                                    <base-switch v-model="allowRegistration" class="mr-1 mb-0"></base-switch>
                                  </div>
                                  <div v-if="isLocal === '0'" class="col-lg-4 col-md-4">
                                    <label class="w-100 form-control-label small-label" for="isForceFollowing">Force Following </label>
                                    <base-switch v-model="isForceFollowing" class="mr-1 mb-0"></base-switch>
                                  </div>
                                </div>
                              </b-form-group>
                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label v-if="isLocal === '1'" class="w-100 form-control-label small-label" for="isCompanyDefault"
                                  >Company Default Channel
                                </label>
                                <base-switch v-if="isLocal === '1'" v-model="isCompanyDefault" class="mr-1 mb-0"> </base-switch>
                              </b-form-group>
                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="displayChannelNameInApp">Suppress Channel Types </label>
                                <base-switch v-model="surpressChannelInApp" class="mr-1 mb-0"> </base-switch>
                              </b-form-group>
                              <b-form-group role="group" class="has-feedback">
                                <label class="w-100 form-control-label" for="accessCode">Access Code </label>
                                <input
                                  v-model="accessCode"
                                  type="text"
                                  name="accessCode"
                                  placeholder="Enter Access Code"
                                  maxlength="6"
                                  class="form-control no-instruction" />
                                <span class="has-icon-feedback"></span>
                              </b-form-group>

                              <b-form-group role="group" class="has-feedback">
                                <label class="w-100 form-control-label" for="coopFund">COOP Funds </label>
                                <input
                                  v-model.trim="coopFund"
                                  type="text"
                                  name="coopFund"
                                  placeholder="Enter COOP Funds"
                                  class="form-control no-instruction"
                                  @input="onlyNumbers()" />
                                <span class="has-icon-feedback"></span>
                              </b-form-group>

                              <b-form-group role="group" class="mb-0 has-feedback">
                                <b-form-group class="mb-0">
                                  <base-input label="Notes" class="mb-0">
                                    <textarea v-model="notes" class="form-control" resize="none" maxlength="100" name="notes" rows="2"></textarea>
                                  </base-input>
                                  <small class="float-right mt-2 text-bold">{{ maxMessageCount - notes.length }} Characters Remaining</small>
                                </b-form-group>
                              </b-form-group>

                              <b-form-group v-if="!isCompanyDefault" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="packageID">Member Benefit Package </label>
                                <b-form-select v-model="packageID" :options="packages" name="packageID" placeholder="Please Select Package"> </b-form-select>
                              </b-form-group>

                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="priceplan">Price Plan </label>
                                <b-form-select v-model="selectedPricePlan" :options="formattedPricePlanList" name="priceplan" placeholder="Select Price Plan">
                                </b-form-select>
                              </b-form-group>

                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="resellerCode">Reseller Code</label>
                                <input
                                  v-model.trim="resellerCode"
                                  v-validate="'alpha_num|max:6'"
                                  type="text"
                                  name="resellerCode"
                                  data-vv-name="resellerCode"
                                  placeholder="Enter reseller code"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('resellerCode'),
                                    'has-invalid': errors.has('resellerCode'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('resellerCode')">
                                  {{ errors.first('resellerCode') }}
                                </div>
                              </b-form-group>

                              <b-form-group role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="partnerAccountNumber">Partner Account Number</label>
                                <input
                                  v-model.trim="partnerAccountNumber"
                                  v-validate="'alpha_num|max:100'"
                                  type="text"
                                  name="partnerAccountNumber"
                                  data-vv-name="partnerAccountNumber"
                                  placeholder="Enter any account reference #"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('partnerAccountNumber'),
                                    'has-invalid': errors.has('partnerAccountNumber'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('partnerAccountNumber')">
                                  {{ errors.first('partnerAccountNumber') }}
                                </div>
                              </b-form-group>

                              <b-form-group v-if="selectedPricePlan" :disabled="revenueCollectionMode !== 'Both'" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="has_app_display_links_first">Revenue Collection Mode:</label>
                                <label class="form-control-label" for="has_app_display_links_first">Payment Card &nbsp &nbsp &nbsp</label>
                                <base-switch v-model="selectedRevenueModeSwitch" class="mr-1 accessCode" on-text="" off-text=""> </base-switch>
                                <label class="form-control-label" for="has_app_display_links_first">&nbsp &nbsp &nbsp Invoice</label>
                                <span class="has-icon-feedback"></span>
                              </b-form-group>

                              <b-form-group role="group" class="mb-3 has-feedback no-gutters">
                                <label class="w-100 form-control-label"
                                  >Mobile App Badge Icon <br /><small
                                    >(Note: Upload in PNG and transparent format for better quality. Use <strong>1024px x 1024px (IOS)</strong> or
                                    <strong>864px x 864px (Android)</strong>)</small
                                  ></label
                                >
                                <b-form-file
                                  id="appIconImage"
                                  ref="appIconImage"
                                  v-model="appIconImage"
                                  accept="image/png, image/jpeg"
                                  name="appIconImage"
                                  placeholder="Choose or Drag app icon here..."
                                  drop-placeholder="Drop app icon here..."
                                  :class="{
                                    hidden: appIconUrl,
                                    'is-invalid': hasAppIconError,
                                    'has-invalid': hasAppIconError,
                                  }"
                                  class="mt-1 uploadIcon form-control"
                                  @change="appIconFileChange($event)"></b-form-file>
                                <div class="invalid-feedback" :is-invalid="hasAppIconError">
                                  {{ appIconError }}
                                </div>
                                <div v-if="appIconUrl" class="appIconContainer" style="background: #e9ecef !important; border: 2px solid #607d8b !important`">
                                  <a class="upload-image-link" onclick="document.getElementById('appIconImage').click()">
                                    <div class="upload-image-overlay">Choose image here...</div>
                                    <img v-if="appIconUrl" :src="appIconUrl" class="mw-100 mx-auto image-preview" />
                                  </a>
                                </div>
                                <div v-if="appIconDownloadLink" class="w-100">
                                  <a class="btn btn-vobo btn-sm mt-2" :href="appIconDownloadLink" target="_blank">Download</a>
                                </div>
                              </b-form-group>

                              <b-form-group role="group" class="mb-3 has-feedback no-gutters">
                                <label class="w-100 form-control-label"
                                  >Splash screen image <br /><small
                                    >(Note: Upload in PNG and transparent format for better quality. <br />
                                    Use
                                    <strong>828px x 1792px / 1792px x 828px (IOS)</strong>
                                    <br />
                                    or
                                    <strong>480px x 720px / 720px x 480px (Android)</strong>)</small
                                  ></label
                                >
                                <b-form-file
                                  id="splashScreen"
                                  ref="splashScreen"
                                  v-model="splashScreen"
                                  accept="image/png"
                                  name="splashScreen"
                                  placeholder="Choose or Drag app splash screen here..."
                                  drop-placeholder="Drop app splash screen here..."
                                  :class="{
                                    hidden: splashScreenUrl,
                                    'is-invalid': hasSplashScreenError,
                                    'has-invalid': hasSplashScreenError,
                                  }"
                                  class="mt-1 uploadIcon form-control"
                                  @change="appSplashScreenFileChange($event)"></b-form-file>
                                <div class="invalid-feedback" :is-invalid="hasSplashScreenError">
                                  {{ splashScreenError }}
                                </div>
                                <div
                                  v-if="splashScreenUrl"
                                  class="appIconContainer"
                                  style="background: #e9ecef !important; border: 2px solid #607d8b !important`">
                                  <a class="upload-image-link" onclick="document.getElementById('splashScreen').click()">
                                    <div class="upload-image-overlay">Choose image here...</div>
                                    <img v-if="splashScreenUrl" :src="splashScreenUrl" class="mw-100 mx-auto image-preview" />
                                  </a>
                                </div>
                                <div v-if="splashScreenDownloadLink" class="w-100">
                                  <a class="btn btn-vobo btn-sm mt-2" :href="splashScreenDownloadLink" target="_blank">Download</a>
                                </div>
                              </b-form-group>

                              <!-- External APIs Form -->
                              <div v-if="!isCompanyDefault && !loadingCP && !externalApisListLoading" class="pt-1 pb-1 column">
                                <b-form-group v-for="api in numApis" :key="api" role="group" class="mb-3 has-feedback">
                                  <label class="form-control-label">External API</label>
                                  <button class="btn btn-outline opacity-8 pull-right" type="button" @click="removeThisApi(api)">
                                    <i class="fa fa-minus-circle"></i>
                                    Remove External API
                                  </button>
                                  <b-form-select
                                    v-model="selectedApiIds[api]"
                                    :options="allExternalApisOptions"
                                    name="selectedApiIds[api]"
                                    placeholder="Please select an external API" />
                                  <div v-if="selectedApis[api]" class="pt-1 pb-1 column">
                                    <b-form-group v-for="field in selectedApis[api].requiredFields" :key="field.id" role="group" class="mb-3 has-feedback">
                                      <label class="w-100 form-control-label">{{ field.name }}</label>
                                      <input
                                        v-if="field.type === 'String'"
                                        v-model="field.value"
                                        v-validate="'required'"
                                        type="text"
                                        data-vv-name="`${field.id}`"
                                        data-vv-scope="`${selectedApis[api].id}`"
                                        class="form-control no-instruction"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(`${selectedApis[api].id}.${field.id}`),
                                          'has-invalid': errors.has(`${selectedApis[api].id}.${field.id}`),
                                        }" />
                                      <input
                                        v-if="field.type === 'Number'"
                                        v-model="field.value"
                                        v-validate="'required'"
                                        type="number"
                                        data-vv-name="`${field.id}`"
                                        data-vv-scope="`${selectedApis[api].id}`"
                                        class="form-control no-instruction"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(`${selectedApis[api].id}.${field.id}`),
                                          'has-invalid': errors.has(`${selectedApis[api].id}.${field.id}`),
                                        }" />
                                      <b-form-select
                                        v-if="field.type === 'Option'"
                                        v-model="field.value"
                                        v-validate="'required'"
                                        :options="field.options"
                                        data-vv-name="`${field.id}`"
                                        data-vv-scope="`${selectedApis[api].id}`"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has(`${selectedApis[api].id}.${field.id}`),
                                          'has-invalid': errors.has(`${selectedApis[api].id}.${field.id}`),
                                        }" />

                                      <span class="has-icon-feedback"></span>
                                      <div class="invalid-feedback" :is-invalid="errors.has(`${selectedApis[api].id}.${field.id}`)">
                                        {{ errors.first(`${selectedApis[api].id}.${field.id}`) }}
                                      </div>
                                    </b-form-group>
                                  </div>
                                </b-form-group>
                                <button class="btn btn-vobo opacity-8" type="button" @click="addExternalApi()">
                                  <i class="fa fa-plus-circle"></i>
                                  Add External API
                                </button>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <b-form-group v-if="action === 'create' && unionTypes.length === 1" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="phone">Contact Phone </label>
                                <input
                                  v-model.trim="phone"
                                  v-validate="'required|phone'"
                                  type="text"
                                  name="phone"
                                  data-vv-name="phone"
                                  data-vv-delay="1000"
                                  placeholder="(999) 999-999"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('phone'),
                                    'has-invalid': errors.has('phone'),
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('phone')">
                                  {{ errors.first('phone') }}
                                </div>
                              </b-form-group>
                              <b-form-group v-if="action === 'create'" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="password"
                                  >Password
                                  <small v-if="passwordShow" class="pull-right mr-1"
                                    ><a><i class="text-gray" :class="iconType.password" @click="switchVisibility('password')"></i></a></small
                                ></label>
                                <input
                                  id="newPassword"
                                  v-model.trim="password"
                                  v-validate="'required'"
                                  :type="passwordFieldType.password"
                                  name="newPassword"
                                  data-vv-as="password"
                                  data-vv-name="password"
                                  data-vv-delay="1000"
                                  placeholder="Enter password"
                                  class="form-control no-instruction"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('password'),
                                    'has-invalid': errors.has('password') || (password.length > 0 && progressWidth <= 40),
                                    'has-valid': progressWidth >= 75 && hasLowercaseUppercase && hasNumber && hasSpecialChar,
                                    'has-warning': password.length > 0 && progressWidth > 40 && progressWidth < 75,
                                  }"
                                  @input="passwordCheck" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('password')">
                                  {{ errors.first('password') }}
                                </div>
                              </b-form-group>
                              <b-col v-if="action === 'create'" lg="12" md="12" class="order-md-last text-default strong">
                                <small class="font-weight-bold">Your password must not contain any blank spaces and meet the following criteria:</small>
                                <ul class="list-icon pt-3">
                                  <li
                                    :class="{
                                      'icon-check-circle-o muted': password.length == 0,
                                      'icon-check-circle valid': password.length >= 8,
                                      'icon-warning invalid': password.length < 8 && password.length > 0,
                                    }">
                                    8 characters
                                  </li>
                                  <li
                                    :class="{
                                      'icon-check-circle-o muted': hasLowerCase === false && hasUpperCase === false,
                                      'icon-exclamation-circle warning': (!hasLowerCase && hasUpperCase) || (hasUpperCase === false && hasLowerCase),
                                      'icon-check-circle valid': hasLowercaseUppercase,
                                      'icon-warning invalid': hasLowercaseUppercase === false && password.length > 0,
                                    }">
                                    Uppercase and lowercase letters
                                  </li>
                                  <li
                                    :class="{
                                      'icon-check-circle-o muted': password.length == 0,
                                      'icon-check-circle valid': hasNumber,
                                      'icon-warning invalid': !hasNumber && password.length > 0,
                                    }">
                                    Number(s)
                                  </li>
                                  <li
                                    :class="{
                                      'icon-check-circle-o muted': password.length == 0,
                                      'icon-check-circle valid': hasSpecialChar,
                                      'icon-warning invalid': !hasSpecialChar && password.length > 0,
                                    }">
                                    Special character(s)
                                  </li>
                                </ul>
                                <div class="progress">
                                  <div
                                    class="progress-bar passwordMeter"
                                    role="progressbar"
                                    :style="{
                                      width: progressWidth + '%',
                                    }"
                                    aria-valuenow="0"
                                    aria-valuemin="0"
                                    aria-valuemax="100">
                                    {{ progressLabel }}
                                  </div>
                                </div>
                              </b-col>
                              <b-form-group v-if="action === 'create'" role="group" class="mb-3 has-feedback">
                                <label class="w-100 form-control-label" for="confirmPassword">Confirm Password</label>
                                <input
                                  v-model.trim="confirmPassword"
                                  v-validate="`required|confirmPassword:${password}`"
                                  type="password"
                                  name="confirmPassword"
                                  data-vv-as="password confirmation"
                                  placeholder="Re-enter password"
                                  class="form-control no-instruction"
                                  data-vv-name="confirmPassword"
                                  data-vv-delay="1000"
                                  data-vv-scope="account"
                                  :class="{
                                    input: true,
                                    'is-invalid': errors.has('account.confirmPassword'),
                                    'has-invalid': errors.has('account.confirmPassword'),
                                    'has-valid': !errors.has('account.confirmPassword') && confirmPassword.length >= 8,
                                  }" />
                                <span class="has-icon-feedback"></span>
                                <div class="invalid-feedback" :is-invalid="errors.has('account.confirmPassword')">
                                  {{ errors.first('account.confirmPassword') }}
                                </div>
                              </b-form-group>

                              <b-form-group role="group" class="has-feedback">
                                <label class="w-100 form-control-label" for="image">Image </label>
                                <b-form-file
                                  id="image"
                                  ref="coverPhotofileInput"
                                  v-model="image"
                                  accept="image/png, image/jpeg"
                                  placeholder="Choose or Drag photo here..."
                                  drop-placeholder="Drop file here..."
                                  :class="{ hidden: imageUrl }"
                                  class="uploadPhotos"
                                  @change="imageFileChange"
                                  @ondrop="imageFileChange"
                                  @ondragover="imageFileChange"></b-form-file>
                                <div v-if="imageUrl" class="imageContainer">
                                  <a class="upload-image-link" onclick="document.getElementById('image').click()">
                                    <div class="upload-image-overlay">Choose photo...</div>
                                    <img v-if="imageUrl" :src="imageUrl" alt="" class="mw-100 mx-auto image-preview" />
                                  </a>
                                </div>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="featuredLinks">Premium Feature Links </label>
                                <base-switch v-model="featuredLinks" class="mr-1 mb-0"></base-switch>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="linkFirst">App Display: Links First</label>
                                <base-switch v-model="linkFirst" class="mr-1 mb-0"></base-switch>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="allowLogoOverwrite">Allow to Update App Logo</label>
                                <base-switch id="allowLogoOverwrite" v-model="allowLogoOverwrite" class="mr-1 mb-0" name="allowLogoOverwrite"></base-switch>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="enablePrivateVideo">Enable Private Video (Vidcast)</label>
                                <base-switch id="enablePrivateVideo" v-model="enablePrivateVideo" class="mr-1 mb-0" name="enablePrivateVideo"></base-switch>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="unregisteredMemberMessaging"
                                  >Enable Unregistered Member Messaging</label
                                >
                                <base-switch
                                  id="unregisteredMemberMessaging"
                                  v-model="unregisteredMemberMessaging"
                                  class="mr-1 mb-0 pull-left"
                                  name="unregisteredMemberMessaging"></base-switch>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="sendTextMessagesOnRegistration"
                                  >Send Text Messages On Registration</label
                                >
                                <base-switch
                                  id="sendTextMessagesOnRegistration"
                                  v-model="sendTextMessagesOnRegistration"
                                  class="mr-1 mb-0 pull-left"
                                  name="sendTextMessagesOnRegistration"></base-switch>
                              </b-form-group>

                              <b-form-group role="group" class="mb-1 has-feedback">
                                <label class="w-100 form-control-label small-label" for="inviteFormOptions.pwa">Allow PWA invite form</label>

                                <base-switch
                                  id="inviteFormOptions.pwa"
                                  v-model="inviteFormOptions.pwa"
                                  class="mr-1 mb-0 pull-left"
                                  name="inviteFormOptions.pwa"></base-switch>

                                <label class="w-100 form-control-label small-label" for="inviteFormOptions.channelInvite"
                                  >Allow classic channel invite form</label
                                >

                                <base-switch
                                  id="inviteFormOptions.channelInvite"
                                  v-model="inviteFormOptions.channelInvite"
                                  class="mr-1 mb-0 pull-left"
                                  name="inviteFormOptions.channelInvite"></base-switch>
                              </b-form-group>
                              <div v-if="false" class="col-lg-12 col-md-12 col-sm-12">
                                <label class="w-100 form-control-label">Links </label>
                                <br />
                                <span v-if="linkList.length > 0"
                                  >(
                                  <small>use <i class="fas fa-arrows-alt"></i> to drag the links container to sort them</small>
                                  )<br /><br
                                /></span>
                                {{ allError }}
                              </div>

                              <draggable
                                v-if="false"
                                tag="div"
                                :component-data="componentData"
                                :list="linkList"
                                class="col-lg-12 w-100"
                                handle=".handleDrag"
                                draggable=".listRowLink "
                                @start="dragging = true"
                                @end="dragging = false">
                                <div v-for="(item, index) in linkList" :key="index" class="col-lg-12 col-md-12 col-sm-12 mb-1 listRowLink no-gutters">
                                  <div v-b-toggle="`linkContainer${index}`" class="collapseLink">
                                    <div class="col-lg-12 no-gutters">
                                      <div class="row">
                                        <div class="linkDrag">
                                          <i class="fas fa-arrows-alt handleDrag cursor-grab"></i>
                                        </div>
                                        <div class="col-lg-9 col-md-9 padding-6 cursor-pointer">
                                          <h6 class="heading-small m-0">
                                            <i class="fas fa-link text-vobo text-icon"></i>
                                            {{ item.title ? item.title : 'Link ' + (index + 1) }}
                                          </h6>
                                        </div>
                                        <div class="col-lg-1 col-md-1 padding-6">
                                          <a v-b-tooltip.hover class="closeLinkContent text-gray" title="Remove Row" @click="removeRow($event, index)"
                                            ><i class="far fa-times-circle"></i
                                          ></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <b-collapse :id="`linkContainer${index}`" class="w-100 collapse visible">
                                    <div class="row mt-2 mx-3">
                                      <div class="col-lg-5 no-gutter-left">
                                        <b-form-group role="group" class="mb-3 has-feedback">
                                          <label class="w-100 form-control-label" :for="'icon' + index">Icon </label>
                                          <b-form-file
                                            :id="'icon' + index"
                                            v-model="icon[index]"
                                            accept="image/png, image/jpeg"
                                            :name="'icon' + index"
                                            placeholder="Select or Drag Icon here"
                                            :class="{
                                              hidden: linkList[index].iconUrl || linkList[index].icon,
                                              'is-invalid': hasIconError[index],
                                              'has-invalid': hasIconError[index],
                                            }"
                                            class="uploadPhotos form-control"></b-form-file>
                                          <div class="invalid-feedback" :is-invalid="hasIconError[index]">
                                            {{ iconError[index] }}
                                          </div>
                                          <div v-if="linkList[index].iconUrl || linkList[index].icon" class="iconContainer">
                                            <a class="upload-image-link" @click="changeIcon(index)">
                                              <div class="upload-image-overlay">Choose icon</div>
                                              <img
                                                v-if="linkList[index].iconUrl || linkList[index].icon"
                                                :src="linkList[index].iconUrl || linkList[index].icon"
                                                class="mw-100 mx-auto image-preview" />
                                            </a>
                                          </div>
                                        </b-form-group>
                                      </div>
                                      <div class="col-lg-7 col-md-9 col-sm-12 no-gutter-right">
                                        <b-form-group role="group" class="mb-3 has-feedback">
                                          <label class="w-100 form-control-label" :for="`${linkList[index].title}`">Title </label>
                                          <input
                                            v-model.trim="linkList[index].title"
                                            v-validate="'required'"
                                            type="text"
                                            :name="'title' + index"
                                            data-vv-as="title"
                                            placeholder="Enter Title"
                                            class="form-control no-instruction"
                                            :class="{
                                              input: true,
                                              'is-invalid': errors.has('title' + index),
                                              'has-invalid': errors.has('title' + index),
                                            }" />

                                          <div class="invalid-feedback" :is-invalid="errors.has('title' + index)">
                                            {{ errors.first('title' + index) }}
                                          </div>
                                        </b-form-group>
                                      </div>
                                    </div>
                                    <div class="row mb-1 mx-3">
                                      <div class="col-lg-12 col-md-12 col-sm-12 no-gutters">
                                        <b-form-group role="group" class="mb-3 has-feedback">
                                          <label class="w-100 form-control-label" for="`${'link'+index}"
                                            >Link <small>(Please use http: or https://)</small></label
                                          >
                                          <input
                                            v-model.trim="linkList[index].link"
                                            v-validate="`required|url: {require_protocol: true }`"
                                            type="text"
                                            :name="'link' + index"
                                            data-vv-as="link"
                                            placeholder="Enter Link"
                                            class="form-control no-instruction"
                                            :class="{
                                              input: true,
                                              'is-invalid': errors.has('link' + index),
                                              'has-invalid': errors.has('link' + index),
                                            }" />
                                          <div class="invalid-feedback" :is-invalid="errors.has('link' + index)">
                                            {{ errors.first('link' + index) }}
                                          </div>
                                        </b-form-group>
                                      </div>
                                    </div>
                                  </b-collapse>
                                </div>
                              </draggable>
                              <div v-if="false" class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                  <div class="col-lg-12 my-3">
                                    <a
                                      :class="{
                                        disabled: linkList.length >= 5,
                                      }"
                                      :disabled="{
                                        disabled: linkList.length === 5,
                                      }"
                                      class="text-success btn btn-outline-success hover-white"
                                      @click="addRow(1)"
                                      ><i class="fas fa-plus-circle"></i> Add Link</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row mt-5 px-4">
                            <div class="col-lg-5 col-md-5 col-12">
                              <router-link ref="clear" :to="cpCancelLink($route.query.q)" exact class="btn btn-outline-vobo pr-5 pl-5 w-sm-100"
                                >Cancel</router-link
                              >
                            </div>
                            <div class="col-lg-7 col-md-7 col-12">
                              <button
                                id="createCPButton"
                                type="button"
                                :disabled="loading"
                                class="btn btn-vobo float-right w-sm-100 mb-3 mb-md-0"
                                @click="processContentProvider">
                                {{ action === 'create' ? 'Create Content Provider' : 'Save Changes' }}
                                <span class="promise-btn__spinner-wrapper hidden"
                                  ><span
                                    data-v-cc3e8e04=""
                                    class="spinner"
                                    style="border-top-color: rgb(52, 152, 219); width: 18px; height: 18px; border-width: 4px; animation-duration: 1s"></span
                                ></span>
                              </button>
                              <router-link class="btn btn-outline-success pull-right mr-4" :to="cpCancelLink($route.query.q)">Back</router-link>
                            </div>
                            <div class="col-lg-8 col-md-8 col-12"></div>
                            <div v-if="loading" class="col-lg-4 col-md-4 col-12 pull-right loadingSubmission mt-2">
                              <span
                                ><span class="text-dafault font-weight-bolder">Loading....</span> <br />Please wait. Updating and assigning force following in
                                channel group and channel category might taking time</span
                              >
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-row>
                  </b-card-body>
                </b-card>
              </div>
            </b-row>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import * as Cookies from 'js-cookie';
import draggable from 'vuedraggable';
import { Validator } from 'vee-validate';
import { phoneRule } from '@/utils/veeValidateRules';

import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import Link from '@ckeditor/ckeditor5-link/src/link';
import Indent from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
import List from '@ckeditor/ckeditor5-list/src/list';
import Font from '@ckeditor/ckeditor5-font/src/font';
import BlockToolbar from '@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar';
import HeadingButtonsUI from '@ckeditor/ckeditor5-heading/src/headingbuttonsui';
import ParagraphButtonUI from '@ckeditor/ckeditor5-paragraph/src/paragraphbuttonui';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import { API_URL } from '@/api/constants/baseUrl';
import { resizeImage } from '@/utils/imageResizeUtils';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

Validator.extend('phone', phoneRule);
Vue.use(Cookies);

const confirmPassword = {
  getMessage: (field) => `The password confirmation does not match`,
  validate(value, param) {
    return new Promise((resolve) => {
      resolve({
        valid: value.toString() === param[0],
        data: value === '' ? { message: `Confirm password field is required` } : '',
      });
    });
  },
};
Validator.extend('confirmPassword', confirmPassword);

export default {
  components: {
    draggable,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          EasyImage,
          EssentialsPlugin,
          SimpleUploadAdapter,
          Heading,
          BoldPlugin,
          ItalicPlugin,
          BlockQuote,
          Underline,
          LinkPlugin,
          ParagraphPlugin,
          Link,
          List,
          Alignment,
          Indent,
          IndentBlock,
          Font,
          HeadingButtonsUI,
          ParagraphButtonUI,
          Alignment,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          Autoformat,
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          'underline',
          'blockQuote',
          '|',
          'bulletedList',
          'numberedList',
          '|',
          'outdent',
          'indent',
          '|',
          'undo',
          'redo',
          '|',
          'link',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'alignment:left',
          'alignment:right',
          'alignment:center',
          'alignment:justify',
          '|',
          'imageUpload',
          'imageStyle:side',
          'imageStyle:full',
        ],
        image: {
          toolbar: ['imageTextAlternative', 'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight'],
          styles: ['full', 'side', 'alignLeft', 'alignCenter', 'alignRight'],
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph',
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2',
            },
          ],
        },
        indentBlock: {
          classes: [
            'custom-block-indent-a', // First step - smallest indentation.
            'custom-block-indent-b',
            'custom-block-indent-c', // Last step - biggest indentation.
          ],
        },
        simpleUpload: {
          uploadUrl: `${API_URL}/ckeditor`,
          withCredentials: true,
          headers: {
            Authorization: `${Cookies.get('user-token')}`,
          },
        },
      },
      dragging: false,
      componentData: {
        props: {
          type: 'transition',
          name: 'flip-list',
        },
      },
      surpressChannelInApp: false,
      revenueCollectionMode: null,
      price_plan_list: [{ plan_name: 'No price plans exist for this organization' }],
      selectedPricePlan: null,
      resellerCode: null,
      partnerAccountNumber: null,
      action: '',
      selectedRevenueModeSwitch: true,
      accountNumber: '',
      contentProvider: {},
      contentProviderID: '',
      companyID: '',
      clientName: '',
      clientDescription: '',
      name: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      accessCode: '',
      coopFund: '',
      notes: '',
      unionTypeID: null,
      categoryID: null,
      groupID: null,
      typeID: null,
      packageID: null,
      isLocal: false,
      prevType: false,
      isCompanyDefault: false,
      allowRegistration: false,
      isForceFollowing: false,
      image: '',
      imageUrl: '',
      userID: '',
      imageFilename: '',
      maxMessageCount: 10000,
      disableSubmitButton: true,
      passwordFieldType: {
        password: 'password',
      },
      iconType: {
        password: 'far fa-eye',
      },
      progressWidth: 0,
      progressLabel: '',
      hasNumber: false,
      hasUpperCase: false,
      hasLowerCase: false,
      hasLowercaseUppercase: false,
      hasSpecialChar: false,
      hasPeriodDash: false,
      hasError: false,
      changePasswordError: '',
      passwordShow: false,
      linkList: [],
      title: [],
      link: [],
      icon: [],
      iconUrl: [],
      allError: '',
      hasIconErrorList: [],
      iconError: [],
      iconFileName: [],
      removedContent: [],
      featuredLinks: true,
      appDisplay: 'link',
      linkFirst: true,
      allowLogoOverwrite: false,
      enablePrivateVideo: false,
      unregisteredMemberMessaging: false,
      appIconImage: '',
      appIconUrl: '',
      appIconImageFilename: '',
      hasAppIconError: false,
      appIconError: '',
      appIconLoaded: false,
      appIconDimension: {
        width: '',
        height: '',
      },
      appIconDownloadLink: false,
      splashScreen: '',
      splashScreenUrl: '',
      splashScreenImageFilename: '',
      hasSplashScreenError: false,
      splashScreenError: '',
      splashScreenLoaded: false,
      splashScreenDimension: {
        width: '',
        height: '',
      },
      splashScreenDownloadLink: false,
      loadingCP: false,
      externalApisList: [],
      numApis: 0,
      selectedApis: [],
      selectedApiIds: [],
      sendTextMessagesOnRegistration: false,
      inviteFormOptions: { pwa: true, channelInvite: true },
    };
  },
  computed: {
    loading: {
      get: function () {
        return this.$store.state.contentProvider.loading;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    formattedPricePlanList() {
      let transformed = [];
      transformed.push({ text: '', value: null });
      for (let i = 0; i < this.price_plan_list.length; i++) {
        transformed.push({
          text: this.price_plan_list[i].plan_name,
          value: this.price_plan_list[i]._id,
        });
      }
      return transformed;
    },
    defaultChannel() {
      return this.$store.state.contentProvider.defaultCompany;
    },
    userCount: {
      get: function () {
        return this.$store.state.contentProvider.selectedCP.userCount;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    categoriesOnly() {
      let data = [];
      let categories = [];
      let groups = [];

      if (this.categoryList.length > 0) {
        this.categoryList.map((category) => {
          data.push({
            value: `${category._id}-category`,
            text: `${category.category}`,
          });
        });

        data.sort((a, b) => a.text.localeCompare(b.text));
      }

      return [{ value: null, text: 'Please select category', disabled: true }, ...data];
    },
    categories() {
      let data = {};
      let categories = [];
      let groups = [];

      if (this.categoryList.length > 0) {
        this.categoryList.map((category) => {
          categories.push({
            value: `${category._id}-category`,
            text: `${category.category}`,
          });
        });

        categories.sort((a, b) => a.text.localeCompare(b.text));
        data['Categories'] = categories;
      }

      if (this.channelGroupList.length > 0) {
        groups.push({ value: '0-all', text: 'All' });
        this.channelGroupList.map((group) => {
          groups.push({ value: `${group._id}-group`, text: `${group.group}` });
        });

        groups.sort((a, b) => a.text.localeCompare(b.text));
        data['Groups'] = groups;
      }

      return data;
    },
    cpTypes() {
      let data = [];

      this.typeList.map((types) => {
        data.push({ value: types._id, text: types.type });
      });

      return [{ value: null, text: 'Please select channel type', disabled: true }, ...data];
    },
    categoryList: {
      get: function () {
        return this.$store.state.contentProvider.cpCategories;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    channelGroupList: {
      get: function () {
        return this.$store.state.contentProvider.cpGroups;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    typeList: {
      get: function () {
        return this.$store.state.contentProvider.cpTypes;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    unionTypes: {
      get: function () {
        let data = [];
        let unionTypes = this.$store.state.contentProvider.unionTypes;

        unionTypes.map((unionType) => {
          data.push({ value: unionType._id, text: unionType.title });
        });

        return [{ value: null, text: 'Please select union type', disabled: true }, ...data];
      },
      set: function (newValue) {
        return newValue;
      },
    },
    packages: {
      get: function () {
        let data = [];
        let packages = this.$store.state.packages.packageList;

        packages.map((packageItem) => {
          data.push({
            value: packageItem.packageID,
            text: packageItem.packageName,
          });
        });

        return [{ value: null, text: 'Please select package', disabled: false }, ...data];
      },
      set: function (newValue) {
        return newValue;
      },
    },
    selectedCompany: {
      get: function () {
        let selectedCompany = this.$store.state.company.selectedCompany || Cookies.get('companyID');
        return selectedCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    companyName: {
      get: function () {
        let company = this.$store.state.company.company || null;
        if (!company) {
          return null;
        }
        return company.name;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    currentCompany: {
      get: function () {
        let currentCompany = this.$store.state.user.companyID;
        return currentCompany;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    currentUserGroup() {
      return this.$store.state.user.userGroup || null;
    },
    cpCancelLink: {
      get: function () {
        return (search) => {
          if (search && search !== '') {
            return `/content-provider/list?q=${search}`;
          } else {
            return `/content-provider/list`;
          }
        };
      },
      set: function (newValue, oldValue) {
        return newValue;
      },
    },
    hasIconError() {
      return this.hasIconErrorList;
    },
    externalApisListLoading() {
      return this.$store.state.settings.externalApisListLoading;
    },
    allExternalApisOptions: {
      get: function () {
        let data = [];

        this.externalApisList.map((apiItem) => {
          data.push({
            value: apiItem.id,
            text: apiItem.name,
          });
        });

        return [
          {
            value: null,
            text: 'Please select an external API',
            disabled: true,
          },
          ...data,
        ];
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  watch: {
    isLocal: function (value) {
      if (value === '1') {
        this.allowRegistration = false;
        this.isForceFollowing = false;
      } else if (value === '0') {
        this.isCompanyDefault = false;
      }
    },
    linkList: function (value) {
      if (value.length === 0) {
        this.link = [];
      }
    },
    icon: function (icons) {
      if (icons) {
        for (var index = 0; index < icons.length; index++) {
          var file = icons[index];
          if (file) {
            this.$set(this.iconUrl, index, URL.createObjectURL(file));
            if (this.iconUrl[index]) {
              this.linkList[index].iconUrl = this.iconUrl[index];
              this.linkList[index].icon = icons[index];
              this.$set(this.hasIconErrorList, index, false);
            }
          }
        }
      }
    },
    appDisplay: function () {},
    selectedApiIds: function (value) {
      const apisById = [];
      value.map((oneApiId) => {
        apisById.push(this.externalApisList.find((oneApi) => oneApi.id === oneApiId));
      });
      let apisWithFieldData = [undefined];
      apisById.map((oneApi) => {
        if (oneApi) {
          const matchedApi = this.selectedApis.find((item) => item?.id === oneApi.id);
          if (matchedApi) {
            oneApi.requiredFields = matchedApi.requiredFields;
          } else {
            oneApi.requiredFields.forEach((element) => {
              element.value = null;
            });
          }
          apisWithFieldData.push(oneApi);
        }
      });
      this.selectedApis = apisWithFieldData;
    },
  },
  beforeMount() {
    this.loadSelectedCompany(this.$store.state.user.company._id);
  },
  mounted() {
    const cpFormContainer = document.getElementById('cpFormContainer');
    cpFormContainer.classList.add('non-clickable');

    let companyID = Cookies.get('companyID') || '';

    if (!companyID || companyID === '') {
      this.$swal
        .fire({
          type: 'warning',
          position: 'center',
          imageWidth: 150,
          title: 'Organization is Required',
          html: 'Please select organization from the dropdown first located in upper left of the screen in order to create content providers',
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Go back to Content Providers',
          confirmButtonClass: 'btn btn-primary pr-5 pl-5',
          footer: '<div class="text-center"> </div>',
          buttonsStyling: false,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.value) {
            this.$router.push('/content-provider');
          }
        });
      cpFormContainer.classList.add('non-clickable');
    } else {
      this.companyID = companyID;
      cpFormContainer.classList.remove('non-clickable');

      this.getCPCategories();
      // this.getUniontypes()
      this.getCPTypes();
      this.getPackages();
      this.getCPGroups();

      this.getPricePlansForCompany(companyID);

      this.getAllExternalApis();

      if (this.$route.params.id) {
        this.getContentProvider(this.$route.params.id);
        this.action = 'edit';
      } else {
        this.action = 'create';
        setTimeout(() => {
          this.email = '';
          this.password = '';

          this.progressWidth = 0;
          this.progressLabel = '';
          this.hasNumber = false;
          this.hasUpperCase = false;
          this.hasLowerCase = false;
          this.hasLowercaseUppercase = false;
          this.hasSpecialChar = false;
          this.hasPeriodDash = false;
          this.hasError = false;

          this.$validator.reset();
          this.errors.clear();
          setTimeout(() => {
            this.$validator.reset();
            this.errors.clear();
          }, 1050);
        }, 1000);
      }
    }
  },
  methods: {
    processContentProvider() {
      if (this.action == 'create') {
        this.createContentProvider();
      } else {
        if (this.userCount > 0 && this.prevType && this.isLocal === '0' && !this.allowRegistration) {
          this.$swal
            .fire({
              position: 'center',
              html: '<div class="py-3">This channel has active primary users. If you continue they will be re-registered with the organization default channel</div> <hr class="mt-4 mb-0">',
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: 'Continue',
              confirmButtonClass: 'btn btn-primary pr-5 pl-5',
              cancelButtonText: 'Cancel',
              cancelButtonClass: 'btn btn-secondary pr-5 pl-5',
              showLoaderOnConfirm: true,
              buttonsStyling: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
            })
            .then((result) => {
              if (result.value) {
                this.updateContentProvider();
              }
            });
        } else {
          this.updateContentProvider();
        }
      }
    },
    getCPCategories() {
      let cpCategories = this.$store.state.contentProvider.cpCategories || [];
      if (cpCategories.length > 0) {
        this.categoryList = cpCategories;
      } else {
        const companyID = Cookies.get('companyID');
        this.$store.dispatch('contentProvider/GET_CP_CATEGORIES', companyID).then((resp) => {
          this.categoryList = this.$store.state.contentProvider.cpCategories;
        });
      }
    },
    getCPTypes() {
      let cpTypes = this.$store.state.contentProvider.cpTypes || [];
      if (cpTypes.length > 0) {
        this.typeList = cpTypes;
      } else {
        const companyID = Cookies.get('companyID');
        this.$store.dispatch('contentProvider/GET_CP_TYPES', companyID).then((resp) => {
          this.typeList = this.$store.state.contentProvider.cpTypes;
        });
      }
    },
    getCPGroups() {
      let cpTypes = this.$store.state.contentProvider.cpGroups || [];
      if (cpTypes.length > 0) {
        this.channelGroupList = cpTypes;
      } else {
        const companyID = Cookies.get('companyID');
        this.$store.dispatch('contentProvider/GET_CP_GROUPS', companyID).then((resp) => {
          this.channelGroupList = this.$store.state.contentProvider.cpGroups;
        });
      }
    },
    getUniontypes() {
      let unionTypes = this.$store.state.contentProvider.unionTypes || [];
      if (unionTypes.length > 0) {
        this.unionTypes = unionTypes;
      } else {
        const companyID = Cookies.get('companyID');
        this.$store.dispatch('contentProvider/GET_CP_UNIONTYPES', companyID).then((resp) => {
          this.unionTypes = this.$store.state.contentProvider.unionTypes;
        });
      }
    },
    getPackages() {
      let packages = this.$store.state.packages.packageList || [];
      if (packages.length > 0) {
        this.packages = packages;
      } else {
        const companyID = Cookies.get('companyID');
        this.$store.dispatch('packages/GET_PACKAGES', companyID).then((resp) => {
          // this.packages = this.$store.packages.packageList
        });
      }
    },
    validateExternalApiFields() {
      this.selectedApis.forEach((api) => {
        api?.requiredFields.forEach((field) => {
          if (field.value == null || (typeof field.value === 'string' && field.value.trim() === '')) {
            this.$validator.errors.add({
              field: field.id,
              msg: `${field.name} in ${api.name} cannot be empyty.`,
              scope: api.id,
              id: `${api.id}.${field.id}`,
            });
          }
        });
      });
    },
    createContentProvider() {
      const promiseBtn = document.getElementById('createCPButton');
      const promiseBtnInner = promiseBtn.querySelector('.promise-btn__spinner-wrapper');
      const cpFormContainer = document.getElementById('cpFormContainer');

      promiseBtnInner.classList.remove('hidden');
      promiseBtn.setAttribute('disabled', 'disabled');
      cpFormContainer.classList.add('non-clickable');

      this.loading = true;
      this.validateExternalApiFields();

      return this.$validator.validateAll().then(async (isValid) => {
        if (isValid && this.errors.items.length === 0) {
          const formData = new FormData();
          var links = [];

          this.selectedApis
            .filter((item) => item)
            .forEach((api) => {
              api.requiredFields.forEach((field) => {
                if (field.type == 'Number' || field.type == 'Option') {
                  field.value = `${field.value}`;
                }
              });
            });

          this.contentProvider = {
            clientName: this.clientName,
            description: this.clientDescription,
            name: this.name,
            email: this.email,
            phoneNumber: this.phone,
            password: this.password,
            access_code: this.accessCode,
            coop_fund: this.coopFund,
            notes: this.notes,
            union_type: this.unionTypeID,
            typeID: this.typeID,
            categoryID: this.categoryID,
            packageID: this.packageID,
            is_local: Boolean(Number(this.isLocal)),
            allowRegistration: this.allowRegistration,
            isForceFollowing: this.isForceFollowing,
            isCompanyDefault: this.isCompanyDefault,
            featuredLinks: this.featuredLinks,
            appDisplay: this.linkFirst ? 'link' : 'message',
            allowLogoOverwrite: this.allowLogoOverwrite,
            enablePrivateVideo: this.enablePrivateVideo,
            unregisteredMemberMessaging: this.unregisteredMemberMessaging,
            pricePlan: this.selectedPricePlan,
            resellerCode: this.resellerCode,
            partnerAccountNumber: this.partnerAccountNumber,
            revenueCollectionMode: this.selectedRevenueModeSwitch ? 'Invoice' : 'Payment Card',
            selectedExternalApis: this.selectedApis.filter((item) => item),
            surpressChannelInApp: this.surpressChannelInApp,
            sendTextMessagesOnRegistration: this.sendTextMessagesOnRegistration,
          };

          if (this.selectedCompany) {
            this.contentProvider.companyID = this.selectedCompany || '';
          } else {
            this.contentProvider.companyID = '';
          }

          const {
            clientName,
            description,
            name,
            email,
            phoneNumber,
            password,
            access_code,
            coop_fund,
            notes,
            union_type,
            typeID,
            categoryID,
            packageID,
            is_local,
            companyID,
            allowRegistration,
            isForceFollowing,
            isCompanyDefault,
            linkList,
            featuredLinks,
            appDisplay,
            allowLogoOverwrite,
            enablePrivateVideo,
            unregisteredMemberMessaging,
            pricePlan,
            resellerCode,
            partnerAccountNumber,
            revenueCollectionMode,
            selectedExternalApis,
            surpressChannelInApp,
            sendTextMessagesOnRegistration,
          } = this.contentProvider;

          formData.append(
            'contentProvider',
            JSON.stringify({
              clientName,
              description,
              name,
              email,
              phoneNumber,
              password,
              access_code,
              coop_fund,
              notes,
              union_type,
              typeID,
              categoryID,
              packageID,
              is_local,
              companyID,
              allowRegistration,
              isForceFollowing,
              isCompanyDefault,
              linkList,
              featuredLinks,
              appDisplay,
              allowLogoOverwrite,
              enablePrivateVideo,
              unregisteredMemberMessaging,
              pricePlan,
              resellerCode,
              partnerAccountNumber,
              revenueCollectionMode,
              selectedExternalApis,
              surpressChannelInApp,
              sendTextMessagesOnRegistration,
            })
          );
          if (this.image != '' && this.image instanceof File) {
            this.image = await resizeImage(600, 600, this.image);
          }

          formData.append('image', this.image);

          formData.append('appIconImage', this.appIconImage);
          formData.append('splashScreen', this.splashScreen);

          this.$store
            .dispatch('contentProvider/CREATE_CONTENT_PROVIDER', formData)
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, 'Content Provider user successfully created');

                this.contentProvider = {};
                this.companyID = '';
                this.clientName = '';
                this.clientDescription = '';
                this.name = '';
                this.email = '';
                this.phone = '';
                this.password = '';
                this.confirmPassword = '';
                this.accessCode = '';
                this.coopFund = '';
                this.notes = '';
                this.unionTypeID = null;
                this.categoryID = null;
                this.packageID = null;
                this.isLocal = false;
                this.allowRegistration = false;
                this.isForceFollowing = false;
                this.isCompanyDefault = false;
                this.image = '';
                this.imageUrl = '';
                this.loading = false;
                this.appDisplay = 'link';
                this.linkFirst = true;
                this.allowLogoOverwrite = false;
                this.enablePrivateVideo = false;
                this.unregisteredMemberMessaging = false;
                this.selectedEApis = [];
                this.surpressChannelInApp = false;
                this.sendTextMessagesOnRegistration = false;

                promiseBtnInner.classList.add('hidden');
                promiseBtn.removeAttribute('disabled', 'disabled');
                cpFormContainer.classList.remove('non-clickable');

                if (this.$route.query && 'q' in this.$route.query && this.$route.query.q !== '') {
                  this.$router.push(`/content-provider/list?q=${this.$route.query.q}`);
                } else {
                  this.$router.push('/content-provider/list');
                }
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, 'Error creating content provider');
                promiseBtnInner.classList.add('hidden');
                promiseBtn.removeAttribute('disabled', 'disabled');
                cpFormContainer.classList.remove('non-clickable');
              }
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
                promiseBtnInner.classList.add('hidden');
                promiseBtn.removeAttribute('disabled', 'disabled');
                cpFormContainer.classList.remove('non-clickable');
              });
            });
        } else {
          promiseBtnInner.classList.add('hidden');
          promiseBtn.removeAttribute('disabled', 'disabled');
          cpFormContainer.classList.remove('non-clickable');
        }
      });
    },
    getPricePlansForCompany(company_id) {
      this.$store.dispatch('priceplans/GET_PRICE_PLAN_LIST', company_id).then((resp) => {
        this.price_plan_list = this.$store.state.priceplans.price_plan_list;
      });
    },
    getContentProvider(cpID) {
      this.loadingCP = true;
      this.$store.dispatch('contentProvider/GET_CONTENT_PROVIDER_BY_ID', cpID).then((resp) => {
        this.contentProviderID = resp._id;
        this.clientName = resp.clientName;
        this.clientDescription = resp.description;
        this.name = resp.contactName;
        this.email = resp.email;
        this.phone = resp.phoneNumber;
        this.accessCode = resp.access_code;
        this.coopFund = resp.coop_fund;
        this.notes = resp.notes;
        this.unionTypeID = resp.union_type;
        this.typeID = resp.typeID;
        this.categoryID = resp.categoryID ? `${resp.categoryID}-category` : resp.groupID !== undefined ? `${resp.groupID}-group` : '0-all';
        this.groupID = resp.groupID || null;
        this.packageID = resp.packageID || resp.packageID === null ? resp.packageID : null;
        this.isLocal = resp.is_local ? '1' : '0';
        this.prevType = resp.is_local;
        this.allowRegistration = resp.allowRegistration;
        this.isForceFollowing = resp.isForceFollowing;
        this.isCompanyDefault = resp.isCompanyDefault;
        this.imageUrl = resp.image;
        this.userID = resp.userid;
        this.imageFilename = resp.imageFilename;
        this.userCount = resp.userCount;
        this.featuredLinks = resp.featuredLinks;
        this.linkFirst = resp.appDisplay === 'link';
        this.appDisplay = resp.appDisplay;
        this.allowLogoOverwrite = resp.allowLogoOverwrite;
        this.enablePrivateVideo = resp.enablePrivateVideo;
        this.unregisteredMemberMessaging = resp.unregisteredMemberMessaging;
        this.appIconUrl = resp.appIconImage;
        this.appIconImageFilename = resp.appIconImageFilename;
        this.splashScreenUrl = resp.splashScreenImage;
        this.splashScreenImageFilename = resp.splashScreenImageFilename;
        this.surpressChannelInApp = resp.surpressChannelInApp;
        this.sendTextMessagesOnRegistration = resp.sendTextMessagesOnRegistration;
        this.inviteFormOptions = resp.inviteFormOptions;
        if (resp.appIconImageFilename) {
          this.appIconDownloadLink = resp.appIconImage;
        }

        if (resp.splashScreenImageFilename) {
          this.splashScreenDownloadLink = resp.splashScreenImage;
        }
        this.orgNumber = ('00' + String(this.$store.state.company.company.companyNumber)).slice(-3);
        this.channelNumber = ('000000' + String(resp.channelNumber)).slice(-7);
        this.accountNumber = `${this.orgNumber}-${this.channelNumber}`;

        this.pricePlan = resp.pricePlan;
        this.selectedPricePlan = this.pricePlan;
        this.resellerCode = resp.resellerCode;
        this.partnerAccountNumber = resp.partnerAccountNumber;
        this.revenueCollectionMode = resp.revenueCollectionMode;

        this.selectedRevenueModeSwitch = this.revenueCollectionMode === 'Invoice' ? true : false;
        if (resp.selectedExternalApis) {
          this.selectedApis = [undefined, ...resp.selectedExternalApis];
          this.selectedApis.forEach((api) => {
            if (api) {
              api.requiredFields.forEach((field) => {
                if (field.type == 'Number' || field.type == 'Option') {
                  field.value = parseInt(field.value);
                }
              });
            }
          });
          this.numApis = resp.selectedExternalApis.length;
        } else {
          this.selectedApis = [undefined];
          this.numApis = 0;
        }
        this.selectedApis.map((api) => {
          this.selectedApiIds.push(api?.id ?? undefined);
        });

        this.loadingCP = false;
      });
    },
    updateContentProvider() {
      const promiseBtn = document.getElementById('createCPButton');
      const promiseBtnInner = promiseBtn.querySelector('.promise-btn__spinner-wrapper');
      const cpFormContainer = document.getElementById('cpFormContainer');

      promiseBtnInner.classList.remove('hidden');
      promiseBtn.setAttribute('disabled', 'disabled');

      this.loading = true;
      this.validateExternalApiFields();

      return this.$validator.validateAll().then(async (isValid) => {
        if (isValid && this.errors.items.length === 0) {
          const formData = new FormData();
          this.selectedApis
            .filter((item) => item)
            .forEach((api) => {
              api.requiredFields.forEach((field) => {
                if (field.type == 'Number' || field.type == 'Option') {
                  field.value = `${field.value}`;
                }
              });
            });

          this.contentProvider = {
            clientName: this.clientName,
            description: this.clientDescription,
            name: this.name,
            email: this.email,
            phoneNumber: this.phone,
            access_code: this.accessCode,
            coop_fund: this.coopFund,
            notes: this.notes,
            union_type: this.unionTypeID,
            typeID: this.typeID,
            categoryID: this.categoryID,
            packageID: this.packageID,
            is_local: Boolean(Number(this.isLocal)),
            allowRegistration: this.allowRegistration,
            isForceFollowing: this.isForceFollowing,
            isCompanyDefault: this.isCompanyDefault,
            imageFilename: this.imageFilename,
            removedContent: this.removedContent,
            featuredLinks: this.featuredLinks,
            appDisplay: this.linkFirst ? 'link' : 'message',
            allowLogoOverwrite: this.allowLogoOverwrite,
            enablePrivateVideo: this.enablePrivateVideo,
            unregisteredMemberMessaging: this.unregisteredMemberMessaging,

            pricePlan: this.selectedPricePlan,
            resellerCode: this.resellerCode,
            partnerAccountNumber: this.partnerAccountNumber,
            revenueCollectionMode: this.selectedRevenueModeSwitch ? 'Invoice' : 'Payment Card',
            selectedExternalApis: this.selectedApis.filter((item) => item),
            surpressChannelInApp: this.surpressChannelInApp,
            sendTextMessagesOnRegistration: this.sendTextMessagesOnRegistration,
            inviteFormOptions: this.inviteFormOptions,
          };

          if (this.selectedCompany) {
            this.contentProvider.companyID = this.selectedCompany || '';
          } else {
            this.contentProvider.companyID = '';
          }

          const {
            clientName,
            description,
            name,
            email,
            phoneNumber,
            access_code,
            coop_fund,
            notes,
            union_type,
            typeID,
            categoryID,
            packageID,
            is_local,
            imageFilename,
            allowRegistration,
            isForceFollowing,
            isCompanyDefault,
            companyID,
            linkList,
            removedContent,
            featuredLinks,
            appDisplay,
            allowLogoOverwrite,
            enablePrivateVideo,
            unregisteredMemberMessaging,
            pricePlan,
            resellerCode,
            partnerAccountNumber,
            revenueCollectionMode,
            selectedExternalApis,
            surpressChannelInApp,
            sendTextMessagesOnRegistration,
            inviteFormOptions,
          } = this.contentProvider;
          const contentProviderID = this.contentProviderID;

          formData.append(
            'contentProvider',
            JSON.stringify({
              clientName,
              description,
              name,
              email,
              phoneNumber,
              access_code,
              coop_fund,
              notes,
              union_type,
              typeID,
              categoryID,
              packageID,
              is_local,
              imageFilename,
              allowRegistration,
              isForceFollowing,
              isCompanyDefault,
              companyID,
              linkList,
              removedContent,
              featuredLinks,
              appDisplay,
              allowLogoOverwrite,
              enablePrivateVideo,
              unregisteredMemberMessaging,
              pricePlan,
              resellerCode,
              partnerAccountNumber,
              revenueCollectionMode,
              selectedExternalApis,
              surpressChannelInApp,
              sendTextMessagesOnRegistration,
              inviteFormOptions,
            })
          );
          formData.append('userData', JSON.stringify({ userID: this.userID }));
          if (this.image != '' && this.image instanceof File) {
            this.image = await resizeImage(600, 600, this.image);
          }

          formData.append('image', this.image);
          formData.append('appIconImage', this.appIconImage);
          formData.append('splashScreen', this.splashScreen);

          this.$store
            .dispatch('contentProvider/UPDATE_CONTENT_PROVIDER', {
              formData,
              contentProviderID,
            })
            .then((res) => {
              if (res.data.success) {
                wrapNotification(this.$notify, NotificationTypes.Success, 'Content Provider user successfully updated');

                this.contentProvider = {};
                this.companyID = '';
                this.clientName = '';
                this.clientDescription = '';
                this.name = '';
                this.email = '';
                this.phone = '';
                this.password = '';
                this.confirmPassword = '';
                this.accessCode = '';
                this.coopFund = '';
                this.notes = '';
                this.unionTypeID = null;
                this.categoryID = null;
                this.packageID = null;
                this.isLocal = false;
                this.allowRegistration = false;
                this.isForceFollowing = false;
                this.isCompanyDefault = false;
                this.image = '';
                this.imageUrl = '';
                this.loading = false;
                this.appDisplay = 'link';
                this.linkFirst = true;
                this.allowLogoOverwrite = false;
                this.enablePrivateVideo = false;
                this.unregisteredMemberMessaging = false;
                this.selectedApis = [];
                this.sendTextMessagesOnRegistration = false;

                if (this.$route.query && 'q' in this.$route.query && this.$route.query.q !== '') {
                  this.$router.push(`/content-provider/list?q=${this.$route.query.q}`);
                } else {
                  this.$router.push('/content-provider/list');
                }

                this.cpCancelLink(this.$route.query.q);
              } else {
                wrapNotification(this.$notify, NotificationTypes.Error, 'Error updating content provider');
              }
              promiseBtnInner.classList.add('hidden');
              promiseBtn.removeAttribute('disabled', 'disabled');
              cpFormContainer.classList.remove('non-clickable');
            })
            .catch((err) => {
              console.error(err);
              err.then((error) => {
                wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords(error.errMessage));
                this.hasError = true;
                promiseBtnInner.classList.add('hidden');
                promiseBtn.removeAttribute('disabled', 'disabled');
                cpFormContainer.classList.remove('non-clickable');
              });
            });
        } else {
          promiseBtnInner.classList.add('hidden');
          promiseBtn.removeAttribute('disabled', 'disabled');
          cpFormContainer.classList.remove('non-clickable');
        }
      });
    },
    clearFields() {
      this.$validator.reset();
      this.errors.clear();
      this.oldPassword = this.password = this.confirmPassword = this.changePasswordError = this.progressLabel = '';
      this.progressWidth = 0;
      this.hasNumber = this.hasUpperCase = this.hasLowerCase = this.hasLowercaseUppercase = this.hasSpecialChar = this.hasPeriodDash = this.hasError = false;
    },
    checkRole: function (val) {
      if (val == 4 && (this.selectedCompany == null || this.selectedCompany == '')) {
        wrapNotification(this.$notify, NotificationTypes.Error, 'Please Select Organization First');
      }
    },
    switchVisibility(field) {
      this.passwordFieldType[field] = this.passwordFieldType[field] === 'password' ? 'text' : 'password';
      this.iconType[field] = this.iconType[field] === 'far fa-eye' ? 'far fa-eye-slash' : 'far fa-eye';
    },
    passwordCheck: function () {
      const password = this.password;
      this.hasNumber = /\d/.test(password);
      this.hasUpperCase = /[A-Z]/.test(password);
      this.hasLowerCase = /[a-z]/.test(password);
      this.hasLowercaseUppercase = /[a-z]/.test(password) && /[A-Z]/.test(password);
      this.hasSpecialChar = /[!@#/$%^&*)(+=#><;:,._-]/.test(password);
      this.hasPeriodDash = !/^\s*?\.|-.*$/.test(password);
      this.level = 0;

      var progressBar = document.querySelectorAll('.passwordMeter');
      var charCounts = {};
      var numCount = 0;
      var upperCaseCount = 0;
      var specialCharCount = 0;

      for (var i = 0; i < password.length; i++) {
        if (/\d/.test(password.charAt(i))) numCount++;
        if (/[A-Z]/.test(password.charAt(i))) upperCaseCount++;
        if (/[!@#/$%^&*)(+=#><;:,._-]/.test(password.charAt(i))) specialCharCount++;
      }

      charCounts.numCount = numCount;
      charCounts.ucCount = upperCaseCount;
      charCounts.scCount = specialCharCount;

      this.progressWidth = this.calcPassStrength(
        password.length,
        this.hasNumber,
        this.hasLowercaseUppercase,
        charCounts,
        this.hasSpecialChar,
        this.hasPeriodDash
      );

      if (this.progressWidth <= 40) {
        [].forEach.call(progressBar, function (el) {
          el.classList.remove('bg-warning');
          el.classList.remove('bg-success');
          el.classList.add('bg-danger');
        });
        this.progressLabel = this.progressWidth >= 30 ? 'Bad Password' : 'Bad';
        this.$validator.errors.add({
          field: 'password',
          msg: 'Password must meet the criteria',
        });
      } else if (this.progressWidth > 40 && this.progressWidth < 75) {
        [].forEach.call(progressBar, function (el) {
          el.classList.remove('bg-danger');
          el.classList.remove('bg-success');
          el.classList.add('bg-warning');
        });
        this.progressLabel = 'Weak Password';
        this.$validator.errors.add({
          field: 'password',
          msg: 'Password must meet the criteria',
        });
      } else if (this.progressWidth >= 75) {
        [].forEach.call(progressBar, function (el) {
          el.classList.remove('bg-warning');
          el.classList.remove('bg-danger');
          el.classList.add('bg-success');
        });
        this.progressLabel = 'Strong Password';

        this.$nextTick(() => {
          this.$validator.errors.remove('password');
        });
      }
    },
    calcPassStrength: function (len, num, lowCap, charCounts, specialChar, periodDash) {
      var level = 0;
      if (len >= 8) {
        level += 18;
      }
      if (charCounts.ucCount === 2) {
        level += 10;
      }
      if (charCounts.ucCount > 2) {
        level += 4;
      }
      if (num) {
        level += 12;
      }
      if (charCounts.numCount > 2) {
        level += 5;
      }
      if (lowCap) {
        level += 22;
      }
      if (specialChar) {
        level += 23;
      }
      if (charCounts.scCount === 2) {
        level += 10;
      }
      if (charCounts.scCount >= 3) {
        level += 12;
      }
      // if (periodDash) { level += 10 }
      if (len === 0) {
        level = 0;
      }
      // console.log(len)
      // console.log(level)
      return level;
    },
    onlyNumbers: function () {
      if (String(this.coopFund.charAt(0)) === '.' || String(this.coopFund.charAt(0)) === '0') {
        this.coopFund = this.coopFund.replace(/[^1-9]/g, '');
      } else {
        this.coopFund = this.coopFund.replace(/[^0-9.]/g, '');
      }
    },
    imageFileChange(e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }
      var reader = new FileReader();
      var self = this;
      reader.addEventListener('load', function (event) {
        var image = event.target;
        self.imageUrl = image.result;
      });

      reader.readAsDataURL(file);
    },
    clearChannelType() {
      this.typeID = null;
    },
    addRow: function (count) {
      var numRows = this.linkList.length;

      if (numRows >= 5) return;

      for (var i = 1; i <= count; i++) {
        this.linkList.push({
          title: '',
          link: '',
          icon: '',
          iconUrl: '',
        });
        if (++numRows == 5) break;
      }
    },
    removeRow: function (row, index) {
      this.removedContent.push({
        index: index,
        icon: this.linkList[index].icon,
        iconFileName: this.linkList[index].iconFileName,
      });
      this.linkList.splice(index, 1);
    },
    changeIcon(index) {
      document.getElementById('icon' + index).click();
    },
    appIconFileChange(e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }
      this.hasAppIconError = false;
      this.appIconError = '';
      (this.appIconUrl = ''), (this.appIconDimension.width = '');
      this.appIconDimension.height = '';
      this.appIconLoaded = false;

      var acceptedFiletypes = ['image/apng', 'image/png'];

      if (file) {
        var fileType = String(file.type);
        if (!acceptedFiletypes.includes(fileType)) {
          this.hasAppIconError = true;
          this.appIconError = 'Invalid File Type. Please upload image in PNG file type only';
          this.appIconImage = '';
          return;
        }

        var reader = new FileReader();
        var self = this;

        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new global.Image();

          img.onload = () => {
            self.appIconDimension.width = img.width;
            self.appIconDimension.height = img.height;

            if (self.appIconDimension.width > 1024) {
              self.hasAppIconError = true;
              self.appIconError = `The image width (${self.appIconDimension.width}px) exceeds the maximum width of (1024px).`;
              return;
            }

            if (self.appIconDimension.height > 1024) {
              self.hasAppIconError = true;
              self.appIconError = `The image height (${self.appIconDimension.height}px) exceeds the maximum height of (1024px).`;
              return;
            }

            if (self.appIconDimension.width < 864) {
              self.hasAppIconError = true;
              self.appIconError = `The image width (${self.appIconDimension.width}px)  is too small (min width: 864px).`;
              return;
            }

            if (self.appIconDimension.height < 864) {
              self.hasAppIconError = true;
              self.appIconError = `The image height (${self.appIconDimension.width}px)  is too small (min height: 864px).`;
              return;
            }

            self.appIconLoaded = true;

            if (!self.hasAppIconError) {
              self.appIconUrl = evt.target.result;
            }
          };

          img.src = evt.target.result;
        };
      }
    },
    loadSelectedCompany() {
      this.$store.dispatch('company/GET_COMPANY_LIST').then((resp) => {
        var companyID = Cookies.get('companyID');
        let company = resp.filter((companyVal) => {
          return companyVal.companyID === companyID;
        });

        this.$store.commit('company/SET_SELECTED_COMPANY', companyID);
        this.$store.commit('company/SET_SELECTED_COMPANY_DETAILS', company[0]);
        this.$root.$store.state.user.companyID = companyID;

        let companyStore = this.$store.state.company.company;
        let faviconIcon = '/favicon.ico';

        if (companyStore === null || companyStore === '' || companyStore === undefined) {
          faviconIcon = '/favicon.ico';
        } else {
          faviconIcon = companyStore.favicon + '?=' + Math.random() || companyStore.logo + '?=' + Math.random();
        }

        var favicon = document.querySelectorAll('.favicon');
        for (var i = 0; i < favicon.length; i++) {
          favicon[i].href = faviconIcon;
        }

        document.title = companyStore ? companyStore.name : 'Vobo';
      });
    },

    appSplashScreenFileChange(e) {
      let file = e.target.files[0];
      if (!file) {
        file = e.dataTransfer.files[0];
      }

      this.hasSplashScreenError = false;
      this.splashScreenError = '';
      (this.splashScreenUrl = ''), (this.splashScreenDimension.width = '');
      this.splashScreenDimension.height = '';
      this.splashScreenLoaded = false;

      var acceptedFiletypes = ['image/apng', 'image/png'];

      if (file) {
        var fileType = String(file.type);
        if (!acceptedFiletypes.includes(fileType)) {
          this.hasSplashScreenError = true;
          this.splashScreenError = 'Invalid File Type. Please upload image in PNG file type only';
          this.appIconImage = '';
          return;
        }

        var reader = new FileReader();
        var self = this;

        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new global.Image();

          img.onload = () => {
            self.splashScreenDimension.width = img.width;
            self.splashScreenDimension.height = img.height;

            if (self.splashScreenDimension.width > 1792) {
              self.hasSplashScreenError = true;
              self.splashScreenError = `The image width (${self.splashScreenDimension.width}px) exceeds the maximum width of (1792px).`;
              return;
            }

            if (self.splashScreenDimension.height > 1792) {
              self.hasSplashScreenError = true;
              self.splashScreenError = `The image height (${self.splashScreenDimension.height}px) exceeds the maximum height of (1792px).`;
              return;
            }

            if (self.splashScreenDimension.width < 480) {
              self.hasSplashScreenError = true;
              self.splashScreenError = `The image width (${self.splashScreenDimension.width}px)  is too small (min width: 480px).`;
              return;
            }

            if (self.splashScreenDimension.height < 480) {
              self.hasSplashScreenError = true;
              self.splashScreenError = `The image height (${self.splashScreenDimension.width}px)  is too small (min height: 480px).`;
              return;
            }

            self.splashScreenLoaded = true;

            if (!self.hasSplashScreenError) {
              self.splashScreenUrl = evt.target.result;
            }
          };

          img.src = evt.target.result;
        };
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    getAllExternalApis() {
      this.$store.dispatch('settings/GET_ALL_EXTERNAL_APIS').then((_) => {
        this.externalApisList = this.$store.state.settings.externalApisList;
      });
    },
    addExternalApi() {
      this.numApis++;
    },
    removeThisApi(apiIndex) {
      this.selectedApiIds.splice(apiIndex, 1);
      this.selectedApis.splice(apiIndex, 1);
      this.numApis--;
    },
  },
};
</script>
<style lang="scss">
.createContentProviderContainer select,
.createContentProviderContainer textarea {
  color: #525f7f !important;
}

.small-label {
  font-size: 13px;
}

.loadingSubmission {
  font-size: 12px;
  color: #3867d6;
}

.listRowLink .custom-file {
  border: 0 !important;
}

.listRowLink .custom-file-label {
  height: calc(1.5em + 1.25rem + 6px);
}

.listRowLink .custom-file-label::after {
  font-family: 'Font Awesome 5 Free' !important;
  content: '\f302' !important;
  display: inline-block;
  vertical-align: middle;
  font-weight: 900;
}

.imageContainer {
  height: 300px;
  position: relative;
  border: 1px solid #bcbcbc;
  border-radius: 7px;
}

.image-preview {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
}

.upload-image-link {
  width: 100%;
  height: 100%;
}

.upload-image-link:hover .upload-image-overlay {
  display: block;
}

.upload-image-overlay {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  text-align: center;
  color: #e5e5e5;
  height: 300px;
  display: none;
  line-height: 300px;
}

.linkDrag {
  width: 50px;
  text-align: center;
}

.collapseLink,
.settingContainer .collapse {
  border: 1px solid #e5e5e5;
  width: 100%;
}

.collapseLink {
  margin-top: 2px;
  background: #ffffff;
  /*cursor: pointer;*/
}

.stylizedHelper {
  background: #3867d6;
  color: #fff;
}

.buttonDrag {
  margin-top: 35px;
}

.handleDrag {
  padding: 12px;
  background: #efefef;
}

.padding-6 {
  padding: 6px;
}

.progress {
  height: 0.95rem !important;
}

.iconContainer {
  height: 80px;
  width: 80px;
  position: relative;
  border: 1px solid #bcbcbc;
  border-radius: 7px;
}

.iconContainer .upload-image-overlay {
  height: 80px;
  width: 80px;
  line-height: 80px;
  font-size: 9px;
}

.appIconContainer {
  position: relative;
}

.uploadIcon .custom-file-label {
  border: none !important;
}

.appIconContainer .upload-image-overlay {
  height: 100%;
  width: 100%;
  line-height: 500px;
}
</style>
